var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistributor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.413 17.916l-1.471 1.47-5.193-5.234h9.626v2.079l4.42-3.639-4.42-3.64v2.08H7.747l5.195-5.436 1.47 1.47.552-5.697-5.698.55 1.47 1.47-8.942 9.185.018.017-.018.018 8.942 8.984-1.47 1.47 5.698.55z",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  })));
}
export default SvgDistributor;